var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9316 1.38944C25.2831 1.74106 25.4805 2.21789 25.4805 2.71507C25.4805 3.21225 25.2831 3.68908 24.9316 4.04069L10.8778 18.0944C10.6921 18.2802 10.4716 18.4276 10.2289 18.5281C9.98622 18.6286 9.72611 18.6804 9.46343 18.6804C9.20075 18.6804 8.94064 18.6286 8.69796 18.5281C8.45528 18.4276 8.23478 18.2802 8.04906 18.0944L1.06656 11.1132C0.887474 10.9402 0.744633 10.7333 0.646366 10.5046C0.548099 10.2758 0.496375 10.0298 0.494211 9.78082C0.492048 9.53186 0.539489 9.28496 0.633766 9.05453C0.728042 8.8241 0.867267 8.61475 1.04332 8.4387C1.21936 8.26265 1.42871 8.12343 1.65914 8.02915C1.88957 7.93488 2.13647 7.88744 2.38543 7.8896C2.63439 7.89176 2.88043 7.94349 3.10919 8.04175C3.33795 8.14002 3.54484 8.28286 3.71781 8.46194L9.46281 14.2069L22.2791 1.38944C22.4532 1.21521 22.6599 1.07699 22.8875 0.982685C23.1151 0.888382 23.359 0.839844 23.6053 0.839844C23.8516 0.839844 24.0956 0.888382 24.3231 0.982685C24.5507 1.07699 24.7574 1.21521 24.9316 1.38944Z",
    fill: "#71A282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.722da09438438be941f5406b464807a4.svg";
export { ForwardRef as ReactComponent };